import { createDrawerEventBinder, formatShippingPostcode, escapeHtml, plainText, formatDelivery } from './cart_drawer_utils.js';

export function initCartDrawerShippingActions({ getDrawer, drawerSelector }) {
    const onDrawer = createDrawerEventBinder(drawerSelector);

    onDrawer('click', '[data-cart-drawer-accordion]', function() {
        const $toggle = $(this);
        const $accordion = $toggle.closest('.cart-drawer-accordion');
        const opening = $toggle.attr('aria-expanded') !== 'true';

        $toggle.attr('aria-expanded', opening);
        $accordion.toggleClass('is-open', opening).find('.cart-drawer-accordion__panel').prop('hidden', !opening);
    });

    // CEP
    onDrawer('input', '#cart-drawer-shipping-form input[name="postcode"]', function() {
        $(this).val(formatShippingPostcode($(this).val()));
    });

    // Cotação de frete por CEP dentro do drawer
    onDrawer('submit', '#cart-drawer-shipping-form', function(event) {
        event.preventDefault();

        const $form = $(this);
        const $result = getDrawer().find('#cart-drawer-shipping-result');
        const postcode = formatShippingPostcode($form.find('input[name="postcode"]').val());

        if (postcode.length < 9) {
            $result.html('<span class="cart-drawer-shipping__error">' + escapeHtml($result.data('msg-invalid')) + '</span>');
            return;
        }

        $form.find('button').prop('disabled', true);
        $result.html('<span class="cart-drawer-shipping__loading"></span>');

        $.ajax({
            url: 'index.php?route=module/shipping/quote',
            type: 'post',
            data: { postcode: postcode },
            dataType: 'json',
            success: function(json) {
                if (json.error && json.error.postcode) {
                    $result.html('<span class="cart-drawer-shipping__error">' + escapeHtml($result.data('msg-invalid')) + '</span>');
                    return;
                }

                let items = '';

                for (const i in (json.shipping_method || {})) {
                    const method = json.shipping_method[i];

                    if (method.error) {
                        continue;
                    }

                    for (const j in method.quote) {
                        const quote = method.quote[j];

                        // A cotação pode ser uma opção direta (tem title) ou um grupo de opções (frenet, frete_rapido...)
                        const options = quote.title !== undefined ? [quote] : Object.values(quote);

                        options.forEach(function(option) {
                            if (!option || option.title === undefined) {
                                return;
                            }

                            // O preço (text) vem com HTML do servidor (ex.: "Grátis" em vermelho); o resto vira texto puro
                            const meta = [formatDelivery(option.delivery_time), plainText(option.info)].filter(Boolean);
                            const meta_html = meta.map(function(line) {
                                return '<small>' + escapeHtml(line) + '</small>';
                            }).join('');

                            items += '<li><span class="cart-drawer-shipping__name"><span class="cart-drawer-shipping__method">' + escapeHtml(plainText(option.title)) + '</span>' + meta_html + '</span><b class="cart-drawer-shipping__price">' + option.text + '</b></li>';
                        });
                    }
                }

                if (items === '') {
                    $result.html('<span class="cart-drawer-shipping__error">' + escapeHtml($result.data('msg-empty')) + '</span>');
                    return;
                }

                $result.html('<ul class="cart-drawer-shipping__list">' + items + '</ul>');
            },
            error: function() {
                $result.html('<span class="cart-drawer-shipping__error">' + escapeHtml($result.data('msg-error')) + '</span>');
            },
            complete: function() {
                $form.find('button').prop('disabled', false);
            }
        });
    });
}
